import request from '@/utils/request'

export function getCourses() {
  return request({
    url: 'delete/GetCourses',
    method: 'post'
  })
}

export function requestDelete(file, fserial, comment) {

  let fileName = file == null ? "" : file.name;
  var fmData = new FormData();

  fmData.append("FSerial", fserial);
  fmData.append("Comment", comment);
  fmData.append("image", file);
  fmData.append("fileName", fileName);


  return request({
    url: "delete/Save",
    method: "post",
    data: fmData,
  });

}

export function getDeleteHistory() {
  return request({
    url: 'delete/history',
    method: 'post'
  })
}

export function removeRequest(requestID, token) {
  return request({
    url: 'delete/remove',
    method: 'post',
    data: {
      requestID: requestID,
      HashToken: token
    }
  })
}










